@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.accordion_item {
  background-color: map.get(core.$colors, simpleWhite);
  border: 1px solid map.get(core.$colors, searchInput);
  outline: none;
  $self: &;

  &:not(:last-child) {
    border-bottom: none;
  }

  &__opened {
    #{ $self }__icon {
      transform: rotate(180deg);
    }

    & > #{ $self }__inner {
      max-height: 100%;
      transition-duration: 0.5s;
      transition-property: max-height;
      transition-timing-function: cubic-bezier(0.895, 0.03, 0.685, 0.22);
    }

    #{ $self }__content {
      opacity: 1;
      transform: translateY(0);
      //transition-delay: 0.2s;
      transition-duration: 0.2s;
      transition-property: opacity, transform;
      transition-timing-function: ease-in-out;
    }

    & > #{ $self }__line {
      outline: none;
    }

    & > .accordion_item__icon {
      transform: rotate(180deg);
    }
  }

  &__line {
    align-items: center;
    background-color: ghostwhite;
    cursor: default;
    display: flex;
    justify-content: space-between;
    outline: 1px solid map.get(core.$colors, searchInput);
    padding: 12px;
    position: relative;
    //z-index: 2;

    &:hover {
      cursor: pointer;
    }
  }

  &__inner {
    max-height: 0;
    overflow: hidden;
    position: relative;
    //text-transform: cubic-bezier(0.95, 0.05, 0.795, 0.035);
    transition-duration: 0.1s;
    transition-property: max-height;
    z-index: 1;
  }

  &__content {
    opacity: 0;
    padding: 12px 12px 0px 12px;
    transform: translateY(-1rem);
    //transition-delay: 0.5s;
    transition-duration: 0.2s;
    transition-property: opacity, transform;
    transition-timing-function: linear, ease;
  }

  &__icon {
    transition: transform 0.3s ease;
    display: flex;
    align-items: center;
    margin-left: 8px;

    &:hover {
      cursor: pointer;
    }
  }
}
